export default "__VITE_ASSET__esF5A1fk__"